import { useEffect, useState } from 'react'
import { getStatus } from './api'
import type { VoiceStatus } from './types'

/** One request per session; a failure is not kept, so the next mount tries again. */
let pending: Promise<VoiceStatus | null> | null = null

function loadStatus(): Promise<VoiceStatus | null> {
  pending ??= getStatus().catch(() => {
    pending = null
    return null
  })
  return pending
}

/** Test hook: forget the session's status. */
export function resetInsprekenStatus(): void {
  pending = null
}

export interface InsprekenStatus {
  status: VoiceStatus | null
  loading: boolean
  /** False while loading, on any error and when the flag is off: entry points hide. */
  available: boolean
}

export function useInsprekenStatus(): InsprekenStatus {
  const [state, setState] = useState<{ status: VoiceStatus | null; loading: boolean }>({
    status: null,
    loading: true,
  })
  useEffect(() => {
    let alive = true
    void loadStatus().then((status) => {
      if (alive) setState({ status, loading: false })
    })
    return () => {
      alive = false
    }
  }, [])
  return { ...state, available: state.status?.available === true }
}
